export enum OnlineType {
  SharedDoc = 'SHARE_DOC',
  DocsSite = 'APIDOC',
}
